module.exports = __webpack_public_path__ + "static/media/bnr5.01ccb17a.jpg";